// extracted by mini-css-extract-plugin
module.exports = {"price":"_3gy3fD","loading":"_36Ptjw"};